import Swal from 'sweetalert2';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
    providedIn: 'root'
})
export class AlertService {

    constructor(private translate: TranslateService) { }

    success(type: string) {
        const title = this.translate.instant(`alert.success.${type}`);
        const message = this.translate.instant(`alert.success.message.${type}`);

        Swal.fire({
            icon: 'success',
            title,
            text: message,
            width: '300px',
            toast: true,
            position: 'bottom-end',
            showConfirmButton: false,
            timer: 2000,
            timerProgressBar: true,
        });
    }

    error(type: string) {
        const title = this.translate.instant(`alert.error.${type}`);
        const message = this.translate.instant(`alert.error.message.${type}`);

        Swal.fire({
            icon: 'error',
            title,
            text: message,
            width: '300px',
            toast: true,
            position: 'bottom-end',
            showConfirmButton: false,
            timer: 2500,
            timerProgressBar: true,
        });
    }

    info(type: string) {
        const title = this.translate.instant(`alert.info.${type}`);
        const message = this.translate.instant(`alert.info.message.${type}`);

        Swal.fire({
            icon: 'info',
            title,
            text: message,
            width: '300px',
            toast: true,
            position: 'bottom-end',
            showConfirmButton: false,
            timer: 5000,
            timerProgressBar: true,
        });
    }

    confirm(type: string): Promise<boolean> {
        const title = this.translate.instant(`alert.confirm.title.${type}`);
        const message = this.translate.instant(`alert.confirm.message.${type}`);
        const confirmButtonText = this.translate.instant(`alert.confirm.buttonConfirm.${type}`);
        const cancelButtonText = this.translate.instant(`alert.confirm.buttonCancel.${type}`);

        return Swal.fire({
            title: title,
            text: message,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: confirmButtonText,
            cancelButtonText: cancelButtonText
        }).then(result => result.isConfirmed);
    }


    showSuccess(title: string, message: string) {
        Swal.fire({
            icon: 'success',
            title,
            text: message,
            width: '300px',
            toast: true,
            position: 'bottom-end',
            showConfirmButton: false,
            timer: 2000,
            timerProgressBar: true,
        });
    }

    showError(title: string, message: string) {
        Swal.fire({
            icon: 'error',
            title,
            text: message,
            width: '300px',
            toast: true,
            position: 'bottom-end',
            showConfirmButton: false,
            timer: 2500,
            timerProgressBar: true,
        });
    }

    showConfirm(title: string, message: string, confirmButtonText: string = 'OK', cancelButtonText: string = 'Cancel'): Promise<boolean> {
        return Swal.fire({
            title: title,
            text: message,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: confirmButtonText,
            cancelButtonText: cancelButtonText
        }).then(result => result.isConfirmed);
    }

    showErrorByResponseCode(code?: number) {
        const errorKey = code ? `ResponseCode.${code.toString()}` : 'ResponseCode.999999';
        const title = this.translate.instant("ResponseCode.title");
        const message = this.translate.instant(errorKey);

        Swal.fire({
            icon: 'error',
            title,
            text: message,
            width: '300px',
            toast: true,
            position: 'bottom-end',
            showConfirmButton: false,
            timer: 2500,
            timerProgressBar: true,
        });
    }
}
